import { zip } from 'lodash'
import { DashboardHeader } from '@modules/admin/Admin.Header'
import AnalyticsSample, { validateSampleField } from '@modules/admin/analytics/Analytics.SampleFilter'
import { doughnutDataParser, lineDataParserTotal } from '@modules/admin/analytics/utils'
import AccessControl from '@modules/auth/AccessControl'
import Loading from '@modules/core/components/Loading'
import SelectCompanyField from '@modules/formFields/SelectCompanyField'
import moment from 'moment'
import React, { Component } from 'react'
import { Doughnut, Line } from 'react-chartjs-2'
import { Trans, withTranslation } from 'react-i18next'
import { compose } from 'redux'
import { Field, Form, reduxForm } from 'redux-form/dist/redux-form'
import Professional from '@services/Professional'
import ExportCsv from '../shared/ExportCsv'
import Title from '../shared/Title'
import { labelsDoughnutPercentatge } from './utils'

class AnalyticsInstallations extends Component {
  state = {
    installationChart: undefined,
    companyChart: undefined,
    deviceChart: undefined,
  }

  client = Professional.analytics

  fetchInstallationsChart = (values) => {
    const filters = {
      startDate:
        values.sample.startDate && moment(values.sample.startDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
      endDate: values.sample.endDate && moment(values.sample.endDate).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      sampleRate: values.sample.sampleRate && values.sample.sampleRate,
      apiKeys: values.companyFilter.length ? values.companyFilter.map((co) => co.api_key).join(',') : undefined,
    }

    return Promise.all([
      this.client
        .getInstallationChart(filters)
        .then((response) => this.setState({ installationChart: response }))
        .catch((e) => {
          window.alert(JSON.stringify(e.message, null, 2))
        }),
      this.client
        .getInstallationsByCompanyChart(filters)
        .then((response) => this.setState({ companyChart: response }))
        .catch((e) => {
          window.alert(JSON.stringify(e.message, null, 2))
        }),
      this.client
        .getInstallationByDeviceChart(filters)
        .then((response) => this.setState({ deviceChart: response }))
        .catch((e) => {
          window.alert(JSON.stringify(e.message, null, 2))
        }),
    ])
  }

  refresh = () => {
    this.fetchInstallationsChart()
  }

  componentDidMount() {
    setTimeout(this.props.submit, 0)
  }

  render() {
    const { installationChart, companyChart, deviceChart } = this.state
    const { handleSubmit, submitting } = this.props
    const optionsDoughnut = {
      tooltips: {
        callbacks: {
          label: labelsDoughnutPercentatge,
        },
      },
      legend: { display: false },
    }

    return (
      <div className="analytics-container">
        <DashboardHeader title={<Trans>Descargas</Trans>} />
        <Form className="container-filters-extended" onSubmit={handleSubmit(this.fetchInstallationsChart)}>
          <div className="filter-extended">
            <Field name="sample" component={AnalyticsSample} validate={validateSampleField} />
            <AccessControl requiredRole="super-admin">
              <Field name="companyFilter" multi component={SelectCompanyField} />
            </AccessControl>
            {this.props.error && (
              <span style={{ color: 'red' }} className="error">
                {this.props.error}
              </span>
            )}
          </div>
          <div className="container-apply-filters">
            <button className="apply-filters" disabled={submitting}>
              <Trans>Aplicar filtros</Trans>
            </button>
          </div>
        </Form>

        <Loading isFetching={submitting} />

        {installationChart && (
          <div className="chart-container">
            <Title title={<Trans>Registros</Trans>}>
              <ExportCsv
                data={zip(installationChart.dates, ...installationChart.datasets.map((dataset) => dataset.data))}
                filename={'Registros.csv'}
                headers={['Fecha', ...installationChart.datasets.map((el) => el.label)]}
              />
            </Title>
            <Line data={lineDataParserTotal(installationChart)} height={70} />
          </div>
        )}
        <div className="container-dognuts chart-container">
          {deviceChart && (
            <div className="dognut-box">
              <Title title={<Trans>Dispositivos</Trans>} total={deviceChart.total} />
              <Doughnut data={doughnutDataParser(deviceChart)} options={optionsDoughnut} />
            </div>
          )}
          {companyChart && (
            <AccessControl requiredRole="super-admin">
              <div className="dognut-box">
                <Title title={<Trans>Compañías</Trans>} total={companyChart.total} />
                <Doughnut data={doughnutDataParser(companyChart)} options={optionsDoughnut} />
                {/*<DoughnutLegends data={ doughnutDataParser(companyChart) }/>*/}
              </div>
            </AccessControl>
          )}
        </div>
      </div>
    )
  }
}

export default compose(
  withTranslation(),
  reduxForm({
    form: 'analytics',
    initialValues: {
      sample: {
        startDate: moment().startOf('week').toDate(),
        endDate: moment().toDate(),
        sampleRate: 'hour',
        id: 'custom',
      },
      companyFilter: [],
    },
    validate: (values) => ({ _error: validateSampleField(values.sample) }),
    destroyOnUnmount: false,
  })
)(AnalyticsInstallations)
